export const MILESTONE_TYPE_SET_INITIAL_STATE = 'MILESTONE_TYPE_SET_INITIAL_STATE';
export const MILESTONE_TYPE_FIND_ALL = 'MILESTONE_TYPE_FIND_ALL';
export const MILESTONE_TYPE_VIEW = 'MILESTONE_TYPE_VIEW';
